function withTrailingSlash(value) {
  return value.endsWith('/') ? value : `${value}/`
}

const isDevelopment = process.env.NODE_ENV !== 'production'

export default {
  // 地址由构建环境决定，避免本地联调时误请求生产服务。
  baseUrl: withTrailingSlash(process.env.VUE_APP_API_BASE_URL || (isDevelopment
    ? 'http://localhost:8080/' : 'https://ai-api.deepcity.cn/')),
  wsUrl: process.env.VUE_APP_WS_URL || (isDevelopment
    ? 'ws://localhost:3000' : 'wss://www.ailonglong.com/wss'),

  // 灰度开关：AI 对话走新版 WebSocket。双轨运行至少 2 周，稳定后删除旧 SSE 路径
  // true  → agent-chat.vue 走 Node WS（chatType=agent）
  // false → 走旧 saveMsg + sendOpen(SSE) 双接口
  useWsAgentChat: true,
}
